import type {
	MarketingRunDetail,
	MarketingRunRecipient,
	MarketingTask,
} from "@/shared/api/generated/types/marketing"

import { marketingRunsListFixture } from "./marketing-fixtures"

const mailingTaskSnapshotFixture: MarketingTask = {
	id: "task-mailing-birthday",
	type: "mailing",
	name: "Скидки именинникам",
	active: true,
	status: "active",
	schedule: {
		mode: "recurring",
		recurring: { frequency: "day", time: "10:00" },
		validity: { kind: "forever" },
		timezone: "Europe/Moscow",
	},
	audience: { rules: [] },
	message: {
		text: "С днём рождения, {имя}! Скидка 20% на косметолога.",
		channels: [
			{ type: "whatsapp", order: 1, enabled: true },
			{ type: "telegram", order: 2, enabled: true },
			{ type: "sms", order: 3, enabled: true },
		],
		priority: "medium",
	},
	createdAt: "2026-06-01T10:00:00.000Z",
	updatedAt: "2026-06-01T10:00:00.000Z",
}

const mailingRecipientsFixture: MarketingRunRecipient[] = [
	{
		recipientId: "recipient-001",
		clientId: "client-001",
		name: "Анна Петрова",
		phone: "+7 900 111-22-33",
		finalChannel: "WhatsApp",
		status: "delivered",
	},
	{
		recipientId: "recipient-002",
		clientId: "client-002",
		name: "Иван Сидоров",
		phone: "+7 900 222-33-44",
		finalChannel: "Telegram",
		status: "delivered",
	},
	{
		recipientId: "recipient-003",
		clientId: "client-003",
		name: "Мария Козлова",
		phone: "+7 900 333-44-55",
		finalChannel: "SMS",
		status: "failed",
		error: "Номер недоступен",
	},
	{
		recipientId: "recipient-004",
		clientId: "client-004",
		name: "Олег Николаев",
		phone: "+7 900 444-55-66",
		finalChannel: "WhatsApp",
		status: "delivered",
	},
	{
		recipientId: "recipient-005",
		clientId: "client-005",
		name: "Елена Волкова",
		phone: "+7 900 555-66-77",
		finalChannel: "SMS",
		status: "failed",
		error: "Превышен лимит",
	},
]

const exportRecipientsFixture: MarketingRunRecipient[] = [
	{
		recipientId: "recipient-101",
		clientId: "client-101",
		name: "Анна Петрова",
		phone: "+7 900 111-22-33",
		status: "delivered",
	},
	{
		recipientId: "recipient-102",
		clientId: "client-102",
		name: "Иван Сидоров",
		phone: "+7 900 222-33-44",
		status: "delivered",
	},
	{
		recipientId: "recipient-103",
		clientId: "client-103",
		name: "Мария Козлова",
		phone: "+7 900 333-44-55",
		status: "delivered",
	},
]

export const marketingRunRecipientsByRunId: Record<
	string,
	MarketingRunRecipient[]
> = {
	"run-mailing-001": mailingRecipientsFixture,
	"run-mailing-002": mailingRecipientsFixture,
	"run-mailing-003": mailingRecipientsFixture,
	"run-mailing-004": mailingRecipientsFixture,
	"run-export-001": exportRecipientsFixture,
	"run-export-002": exportRecipientsFixture,
}

export function getMarketingRunDetailFixture(
	runId: string,
): MarketingRunDetail | null {
	const run = marketingRunsListFixture.data.find((item) => item.id === runId)

	if (!run) {
		return null
	}

	return {
		...run,
		taskSnapshot:
			run.taskType === "mailing" ? mailingTaskSnapshotFixture : undefined,
		reportUrl:
			run.taskType === "report" ? "https://example.com/report.xlsx" : null,
		reportExpiresAt: null,
	}
}

export function listMarketingRunRecipientsFixture(
	runId: string,
	options?: {
		phone?: string
		status?: "delivered" | "failed" | "pending" | "skipped"
		channel?: string
		page?: number
		pageSize?: number
	},
) {
	const page = options?.page ?? 1
	const pageSize = options?.pageSize ?? 20
	let data = [...(marketingRunRecipientsByRunId[runId] ?? [])]

	if (options?.phone) {
		const digits = options.phone.replace(/\D/g, "")
		data = data.filter((recipient) =>
			recipient.phone.replace(/\D/g, "").includes(digits),
		)
	}

	if (options?.status) {
		data = data.filter((recipient) => recipient.status === options.status)
	}

	if (options?.channel && options.channel !== "all") {
		data = data.filter(
			(recipient) => recipient.finalChannel === options.channel,
		)
	}

	const total = data.length
	const start = (page - 1) * pageSize

	return {
		data: data.slice(start, start + pageSize),
		paging: { page, pageSize, total },
	}
}
